export const DATEPICKER_FORMAT = 'YYYY-MM-DD h:mm A'
export const RAILS_FORMAT = 'YYYY-MM-DD HH:mm:ss Z'
export const STANDARD_DATETIME_FORMAT = 'MMM D, hh:mm a'
